import UnicoUtils from "./script-utils.js";

/**
 * 商品詳細ページの全体制御
 */
export default class ProductDetail extends HTMLElement {
  constructor() {
    super();

    // オーダー情報入力エリアの開閉処理の初期化
    this.initProductArea();

    // オーダー情報入力エリアの調整ボタンの初期化
    this.initAdjustButton();

    // オーダー情報入力エリアのsticky制御
    if (this.orderArea) {
      document.addEventListener("DOMContentLoaded", () => this.initStickyArea());
      window.addEventListener("resize", () => this.initStickyArea());
      window.addEventListener('scroll', ()=> this.initStickyArea());
    }

    // 下部固定の表示非表示
    this.bottomMenuShow();
  }

  /**
   * オーダー情報入力エリアの初期化
   */
  initProductArea() {
    this.orderArea = this.querySelector("[data-target-id=order-area]");
    this.closeButton = this.querySelector("[data-target-id=order-close-button]");
    this.orderButtonList = this.querySelectorAll("[data-target-id=order-button]");
    if (this.orderArea && this.closeButton && this.orderButtonList.length > 0) {
      this.orderButtonList.forEach((orderButton) => {
        orderButton.addEventListener("click", (e) => {
          this.toggleOpen(e);
        });
      });
      this.closeButton.addEventListener("click", (e) => {
        this.toggleOpen(e);
      });
    }

    // モーダル表示設定
    const modalButtonList = this.querySelectorAll("[data-modal-target]");
    modalButtonList.forEach((button) => {
      const target = button.getAttribute("data-modal-target");
      const targetPosition = button.getAttribute("data-modal-target-position");
      button.addEventListener("click", () => {
        this.openModal(target, targetPosition);
      })
    });

    // モーダル範囲外をクリック
    if(!this.orderArea) return;
    this.addEventListener("click", (e) => {
      const modalArea = this.orderArea.querySelector(".unico-product-order-form-container");
      if (this.orderArea.classList.contains("-is-active")
        && !modalArea.contains(e.target)
        && e.target.closest("unico-order-modal") === null
        && e.target.getAttribute("data-target-id") !== "order-button"
      ) {
        this.toggleOpen(e);
      }
    }, true);
  }

  /**
   * オーダー情報入力の表示切替
   */
  toggleOpen(e) {
    if (this.orderArea.classList.contains("-is-active")) {
      // ボトムメニューの場合は位置移動
      if (e.target.closest(".unico-bottom-menu")) {
        // オーダーエリアへスクロール（SPのみ）
        const target = this.orderArea.querySelector(".unico-product-order-form-container");
        if (window.getComputedStyle(target).position !== "fixed") {
          this.orderArea.scrollIntoView({
            behavior: 'smooth'
          });
          this.orderButtonList.forEach((orderButton) => {
            orderButton.parentNode.classList.add("-is-hidden");
          });
        }
      } else {
        // オーダーエリアを非表示
        this.orderButtonList.forEach((orderButton) => {
          orderButton.classList.remove("-is-active");
          orderButton.parentNode.classList.remove("-is-hidden");
        });
        this.orderArea.classList.remove("-is-active");
        // モーダルが開いていれば非表示
        this.closeModal();
      }
    } else {
      this.orderButtonList.forEach((orderButton) => {
        orderButton.classList.add("-is-active");
      });
      this.orderArea.classList.add("-is-active");
      // オーダーエリアへスクロール（SPのみ）
      const target = this.orderArea.querySelector(".unico-product-order-form-container");
      if (window.getComputedStyle(target).position !== "fixed") {
        this.orderArea.scrollIntoView({
          behavior: 'smooth'
        });
      }
    }
  }

  /**
   * オーダー情報入力内のモーダル表示
   */
  openModal(target, targetPosition) {
    // モーダルが開いていれば非表示
    this.closeModal();
    // 対象のモーダルを表示
    const modal = this.querySelector(`[data-target-id=${target}]`)
    modal.classList.add("-is-active");
    // モーダルのスクロール位置をリセット
    const modalContent = modal.querySelector('.unico-modal-content');
    modalContent.scrollTop = 0;
    // モーダル内の該当要素までスクロール
    if (targetPosition) {
      const targetElem = this.querySelector(`[data-target-id=${targetPosition}]`)
      targetElem.scrollIntoView();
    }
  }

  /**
   * モーダルを非表示
   */
  closeModal() {
    const modalList = this.querySelectorAll("unico-order-modal");
    modalList.forEach((modal) => {
      modal.classList.remove("-is-active");
    });
  }

  /**
   * 調整モーダルの設定
   */
  initAdjustButton() {
    const adjustModals = this.querySelectorAll("[data-target-id=adjust-modal]");
    const adjustButtons = this.querySelectorAll("[data-target-id=adjust-button]")
    const closeButtons = this.querySelectorAll("[data-target-id=adjust-close-button]")
    const decideButtons = this.querySelectorAll("[data-target-id=adjust-decide-button]")

    if (!adjustModals || !adjustButtons || !closeButtons || !decideButtons) return;
    // 調整ボタン押下で調整モーダルを表示
    
    adjustButtons.forEach((adjustButton, index) => {
      adjustButton.addEventListener("click", () => {
        const previewArea = this.querySelector(".unico-order-preview");
        previewArea.scrollIntoView({
          behavior: 'smooth'
        });
        
        // どの生地タイプのボタンがクリックされたかを判定
        const fabricType = adjustButton.dataset.fabricType || 'main';
        
        if (adjustModals[index].classList.contains("-is-active")) {
          adjustModals[index].classList.remove("-is-active");
        } else {
          adjustModals[index].classList.add("-is-active");
          const targetWrapper = adjustButtons[index].closest(".unico-order-table");
          const targetWidth = adjustModals[index].querySelector('unico-counter-box[data-width] .value');
          const targetHeight = adjustModals[index].querySelector('unico-counter-box[data-height] .value');
          const setTargetWidth = targetWrapper.querySelector('[data-target="order-final-width"]');
          const setTargetHeight = targetWrapper.querySelector('[data-target="order-final-height"]');
          targetWidth.textContent = setTargetWidth.textContent.replace('cm', '');
          targetHeight.textContent = setTargetHeight.textContent.replace('cm', '');
          adjustModals[index].querySelector('[data-width] + .unico-adjust-modal-button').dataset.value = setTargetWidth.textContent.replace('cm', '');
          adjustModals[index].querySelector('[data-height] + .unico-adjust-modal-button').dataset.value = setTargetHeight.textContent.replace('cm', '');
          
          // 調整前のサイズを保存（アラート表示用）
          const orderSection = document.querySelector('wl-order-section');
          if (orderSection) {
            const currentSize = orderSection.getSize();
            orderSection.originalSizeBeforeAdjustment = {
              width: currentSize.width,
              height: currentSize.height
            };
          }
        }
      });
    });
    
    
    // 確定ボタン押下で調整モーダルは閉じる

    decideButtons.forEach((decideButton, index) => {
      decideButton.addEventListener("click", (e) => {
        adjustModals[index].classList.remove("-is-active");
        const targetWrapper = adjustButtons[index].closest(".unico-order-table");
        const targetWidth = e.target.closest('.unico-adjust-modal').querySelector('unico-counter-box[data-width] .value');
        const targetHeight = e.target.closest('.unico-adjust-modal').querySelector('unico-counter-box[data-height] .value');
        const setTargetWidth = targetWrapper.querySelector('[data-target="order-final-width"]');
        const setTargetHeight = targetWrapper.querySelector('[data-target="order-final-height"]');
        setTargetWidth.textContent = targetWidth.textContent + 'cm';
        setTargetHeight.textContent = targetHeight.textContent + 'cm';
        
        // どのモーダルが使われたかを判定
        const modal = e.target.closest('.unico-adjust-modal');
        const fabricType = modal ? modal.dataset.fabricType : 'main';
        
        // 価格再計算を確実に実行
        const orderSection = document.querySelector('wl-order-section');
        if (orderSection) {
          // サブ生地の価格を保持
          const currentSubPrice = orderSection.priceElm?.dataset.subPrice || '0';
          orderSection.resetOrderPriceData(); // 価格データをリセット
          // matomeをawaitで待ってから開き方制御を実行
          orderSection.matome(false, true, fabricType).then(() => {
            // 【修正】仕上がりサイズ調整後の開き方制御を実行
            // 少し遅延を入れて、matome内のvaridationが完了してから実行
            setTimeout(() => {
              const adjustedSize = orderSection.getAdjustedSize(fabricType);
              if (adjustedSize && adjustedSize.width > 0) {
                // 仕上がりサイズ調整前のサイズを取得して比較
                const originalSize = orderSection.originalSizeBeforeAdjustment || orderSection.getSize();
                const isStraight = !!orderSection.querySelector('[data-option-type-code="010"][data-option-code="3"][aria-checked="true"]');
                
                // 調整前のサイズで両開きが可能だったかどうかを判定
                const threshold = isStraight ? 141 : 101;
                const wasBothOpenPossible = originalSize && originalSize.width >= threshold;
                
                // 調整後のサイズで両開きが不可能かどうかを判定
                const isBothOpenImpossible = adjustedSize.width < threshold;
                
                // 両開きが可能だったサイズから両開きが不可能なサイズに変更された場合にアラートを表示
                const shouldShowAlert = wasBothOpenPossible && isBothOpenImpossible;
                
                // まず開き方制御を実行（アラート表示前）
                orderSection.setOpeningTypeControl(adjustedSize, true, false);
                
                // アラート表示のタイミングを遅らせて、すべての処理が完了した後に表示
                if (shouldShowAlert) {
                  // より長い遅延を入れて、すべての処理が完了した後にアラートを表示
                  setTimeout(() => {
                    const hidaType = isStraight ? 'ストレート' : '1.5倍ヒダ・2倍ヒダ';
                    alert(`そのサイズでは両開きは選択できません。\n両開きをご希望の場合は仕上がりサイズを${threshold}cm以上にしてください。\n\n現在の仕上がりサイズ: ${adjustedSize.width}cm\nヒダの種類: ${hidaType}`);
                    
                    // アラート表示後に再度開き方制御を実行して状態を確実に保持
                    orderSection.setOpeningTypeControl(adjustedSize, true, false);
                    
                    // アラート表示後、他の処理で状態が上書きされる可能性があるため、複数回遅延して状態を再設定
                    setTimeout(() => {
                      const bothOpenButton = orderSection.querySelector('[data-option-type-code="030"][data-option-code="1"]');
                      const singleOpenButton = orderSection.querySelector('[data-option-type-code="030"][data-option-code="2"]');
                      if (bothOpenButton && singleOpenButton) {
                        bothOpenButton.disabled = true;
                        bothOpenButton.setAttribute('aria-checked', 'false');
                        singleOpenButton.setAttribute('aria-checked', 'true');
                        const bothOpenWrapper = bothOpenButton.closest('.unico-product-step-block');
                        const singleOpenWrapper = singleOpenButton.closest('.unico-product-step-block');
                        if (bothOpenWrapper) {
                          bothOpenWrapper.style.opacity = 0.5;
                        }
                        if (singleOpenWrapper) {
                          singleOpenWrapper.style.opacity = 1;
                        }
                        orderSection.changePreviewImage(singleOpenButton);
                        orderSection.setOptionName();
                      }
                    }, 0);
                    
                    // 100ms後に再度状態を確認・設定
                    setTimeout(() => {
                      const bothOpenButton = orderSection.querySelector('[data-option-type-code="030"][data-option-code="1"]');
                      const singleOpenButton = orderSection.querySelector('[data-option-type-code="030"][data-option-code="2"]');
                      if (bothOpenButton && singleOpenButton) {
                        bothOpenButton.disabled = true;
                        bothOpenButton.setAttribute('aria-checked', 'false');
                        singleOpenButton.setAttribute('aria-checked', 'true');
                        const bothOpenWrapper = bothOpenButton.closest('.unico-product-step-block');
                        const singleOpenWrapper = singleOpenButton.closest('.unico-product-step-block');
                        if (bothOpenWrapper) {
                          bothOpenWrapper.style.opacity = 0.5;
                        }
                        if (singleOpenWrapper) {
                          singleOpenWrapper.style.opacity = 1;
                        }
                        orderSection.changePreviewImage(singleOpenButton);
                        orderSection.setOptionName();
                      }
                    }, 100);
                    
                    // 500ms後に再度状態を確認・設定
                    setTimeout(() => {
                      const bothOpenButton = orderSection.querySelector('[data-option-type-code="030"][data-option-code="1"]');
                      const singleOpenButton = orderSection.querySelector('[data-option-type-code="030"][data-option-code="2"]');
                      if (bothOpenButton && singleOpenButton) {
                        bothOpenButton.disabled = true;
                        bothOpenButton.setAttribute('aria-checked', 'false');
                        singleOpenButton.setAttribute('aria-checked', 'true');
                        const bothOpenWrapper = bothOpenButton.closest('.unico-product-step-block');
                        const singleOpenWrapper = singleOpenButton.closest('.unico-product-step-block');
                        if (bothOpenWrapper) {
                          bothOpenWrapper.style.opacity = 0.5;
                        }
                        if (singleOpenWrapper) {
                          singleOpenWrapper.style.opacity = 1;
                        }
                        orderSection.changePreviewImage(singleOpenButton);
                        orderSection.setOptionName();
                      }
                    }, 500);
                    
                    // 1000ms後にも再度確認
                    setTimeout(() => {
                      const bothOpenButton = orderSection.querySelector('[data-option-type-code="030"][data-option-code="1"]');
                      const singleOpenButton = orderSection.querySelector('[data-option-type-code="030"][data-option-code="2"]');
                      if (bothOpenButton && singleOpenButton) {
                        bothOpenButton.disabled = true;
                        bothOpenButton.setAttribute('aria-checked', 'false');
                        singleOpenButton.setAttribute('aria-checked', 'true');
                        const bothOpenWrapper = bothOpenButton.closest('.unico-product-step-block');
                        const singleOpenWrapper = singleOpenButton.closest('.unico-product-step-block');
                        if (bothOpenWrapper) {
                          bothOpenWrapper.style.opacity = 0.5;
                        }
                        if (singleOpenWrapper) {
                          singleOpenWrapper.style.opacity = 1;
                        }
                        orderSection.changePreviewImage(singleOpenButton);
                        orderSection.setOptionName();
                      }
                    }, 1000);
                  }, 500); // 500ms遅延してアラートを表示
                }
                
                // 調整前のサイズをクリア（次回の調整に備える）
                orderSection.originalSizeBeforeAdjustment = null;
              }
            }, 100);
          });
          
          // メイン生地のサイズ調整時は、サブ生地の価格を復元（setOrderPriceの後に実行）
          if (fabricType === 'main') {
            // 少し遅延を入れて、setOrderPriceの後に復元
            setTimeout(() => {
              orderSection.priceElm.dataset.subPrice = currentSubPrice;
              orderSection.setOrderPrice(); // 価格表示を再更新
            }, 0);
          }
        }
      });
    });
    
    // 閉じるボタン押下で調整モーダルは閉じる
    closeButtons.forEach((closeButton, index) => {
      closeButton.addEventListener("click", () => {
        adjustModals[index].classList.remove("-is-active");
      });
    });
    

    // 調整モーダル外クリックの判定
    
    this.addEventListener('click', (event) => {
      if (!event.target.closest("[data-target-id=adjust-button]") && !event.target.closest("[data-target-id=adjust-modal]") && this.querySelector(".-is-active [data-target-id=adjust-modal]")) {
        this.querySelector(".-is-active [data-target-id=adjust-modal]").classList.remove("-is-active");
      }
    })

  }

  /**
   * オーダー情報入力内のスクロールエリアの部分固定処理
   */
  initStickyArea() {
    const headerArea = this.orderArea.querySelector(".unico-product-order-form-header");
    const priceArea = this.orderArea.querySelector(".unico-product-price");
    const bottomMenu = document.querySelector(".unico-bottom-menu");
    const stopper = document.querySelector(".unico-section-product-guide");
    const priceAreaHeight = priceArea.clientHeight;
    const orderAreaHeight = this.orderArea.clientHeight;

    if (UnicoUtils.isPC()) {
      this.orderArea.style.setProperty('--unico-product-order-form-padding-top', `${headerArea.offsetHeight}px`);
      this.orderArea.style.setProperty('--unico-product-order-form-padding-bottom', `${priceArea.offsetHeight}px`);

      // SP用スタイルの削除
      priceArea.parentNode.style.paddingTop = '';
      priceArea.classList.remove('-is-bottom-fixed');
      bottomMenu.classList.remove('-is-hidden');
    } else {
      const offsetTop = this.orderArea.offsetTop;
      const offsetTopStopper = stopper.offsetTop;
      const scrollTop = window.scrollY;
      const windowHeight = window.innerHeight;

      if (!this.orderArea.classList.contains('-is-active')) return;

      if (scrollTop < offsetTop - windowHeight) {
        priceArea.parentNode.style.paddingTop = '';
        priceArea.classList.remove('-is-bottom-fixed');
        bottomMenu.classList.remove('-is-hidden');
      } else if (0 <= offsetTop - windowHeight && (offsetTop + orderAreaHeight) - (bottomMenu.clientHeight + windowHeight) >= scrollTop) {
        priceArea.parentNode.style.paddingTop = `${priceAreaHeight}px`;
        priceArea.classList.add('-is-bottom-fixed');
        bottomMenu.classList.remove('-is-visible');
        bottomMenu.classList.add('-is-hidden');
      } else if (scrollTop > offsetTopStopper - windowHeight) {
        priceArea.classList.remove('-is-bottom-fixed');
        bottomMenu.classList.add('-is-hidden');
      } else {
        priceArea.parentNode.style.paddingTop = '';
        priceArea.classList.remove('-is-bottom-fixed');
        bottomMenu.classList.remove('-is-hidden');
      }

      // PC用スタイルの削除
      this.orderArea.style.removeProperty('--unico-product-order-form-padding-top');
      this.orderArea.style.removeProperty('--unico-product-order-form-padding-bottom');
    }
  }

  /**
   * 下部固定の表示非表示
   */
  bottomMenuShow() {
    const detailContent = document.querySelector(".unico-detail");
    const bottomMenu = document.querySelector(".unico-bottom-menu");
    const stopper = document.querySelector(".unico-section-product-guide");

    if (!bottomMenu || !detailContent || !stopper) return;

    function positionElm() {
      if (!detailContent || !stopper || !bottomMenu) return;

      const rectDetail = detailContent.getBoundingClientRect();
      const rectGuide = stopper.getBoundingClientRect();
      const bottomDetail = rectDetail.bottom;
      const bottomGuide = rectGuide.top;
      const distance = bottomGuide - bottomDetail;

      if (bottomMenu.classList.contains("-is-unfixed")) {
        if (UnicoUtils.isPC()) {
          const bottomPosition = (distance - bottomMenu.clientHeight) * -1;
          const calcWidth = (window.innerWidth - detailContent.clientWidth) / 2;
          let rightPosition = null;
          if (calcWidth > 0) {
            rightPosition = calcWidth * -1;
          } else {
            rightPosition = detailContent.clientWidth - window.innerWidth ;
          }
          bottomMenu.style.bottom = bottomPosition + "px";
          bottomMenu.style.right = rightPosition + "px";
        } else {
          const bottomPosition = distance * -1;
          bottomMenu.style.bottom = bottomPosition + "px";
          bottomMenu.style.right = "auto";
        }
      }
    }

    if (UnicoUtils.isPC()) {
      const observer = new MutationObserver(() => {
        if (stopper) {
          positionElm();
          observer.disconnect();

          const stopObserver = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (entry.isIntersecting) {
                  bottomMenu.classList.add("-is-unfixed");
                  positionElm();
                } else {
                  bottomMenu.classList.remove("-is-unfixed");
                  bottomMenu.style.bottom = "auto";
                  bottomMenu.style.right = "0";
                }
              });
            },
            { threshold: 0 }
          );
          stopObserver.observe(stopper);

          window.addEventListener("resize", positionElm);
          const ro = new ResizeObserver(() => positionElm());
          ro.observe(detailContent);
          ro.observe(stopper);
        }
      });
      observer.observe(document.body, { childList: true, subtree: true });
    } else {
      window.addEventListener("scroll", () => {
        if (window.scrollY > 0) {
        bottomMenu.classList.add("-is-visible");
      } else {
        bottomMenu.classList.remove("-is-visible");
      }
      });

      const stopObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              bottomMenu.classList.add("-is-hidden");
            } else {
              bottomMenu.classList.remove("-is-hidden");
            }
          });
        },
        { threshold: 0 }
      );
      stopObserver.observe(stopper);

      window.addEventListener("resize", positionElm);
      const ro = new ResizeObserver(() => positionElm());
      ro.observe(detailContent);
      ro.observe(stopper);
    }
  }

}
